// Maps a cached raw DB row (snake_case columns from the JDBC connector) to the web Article shape, mirroring
// fromBackendArticle (reference->code, prixUnitaire->prixUnitaireHT, fodecApplicable->fodec, active->actif).
import { Article, TauxTva, Unite } from '../types';
import { getCachedRows } from './session';

const str = (v: unknown): string | undefined => (v == null ? undefined : String(v));
const num = (v: unknown): number | undefined => (v == null ? undefined : Number(v));
const asEnum = <T>(v: unknown, fallback: string): T => (v == null ? fallback : String(v)) as unknown as T;

export function mapArticleRow(r: Record<string, unknown>): Article {
  return {
    id: Number(r.id),
    code: str(r.reference) ?? '',
    designation: str(r.designation) ?? '',
    description: str(r.description),
    prixUnitaireHT: num(r.prix_unitaire) ?? 0,
    tauxTva: asEnum<TauxTva>(r.taux_tva, 'TVA_0'),
    unite: asEnum<Unite>(r.unite, 'PIECE'),
    fodec: Boolean(r.fodec_applicable),
    categorie: str(r.categorie),
    reference: str(r.reference),
    codeBarres: str(r.code_barres),
    stockActuel: num(r.stock_actuel),
    stockMinimum: num(r.stock_minimum),
    cmup: num(r.cmup),
    actif: Boolean(r.active),
  };
}

export async function getCachedArticles(): Promise<Article[]> {
  return (await getCachedRows('article')).map(mapArticleRow);
}
